export default "__VITE_ASSET__BPuoxrTM__"